export const ANS_EN = {
    "ocQKxGk5q3FFxBPq9Kdg": { "1": { "optionIndex": 2 } },
    "iZclyXfgpWoy3pa8dqxm": { "1": { "optionIndex": 1 } },
    "lJML7ab0S1Fv2vjpTnBY": { "1": { "optionIndex": 2 } },
    "hbHqrwxUoJ83qkfxJp6a": { "1": { "optionIndex": 1 } },
    "T0TNcv58zwNZ3vxEHEox": { "1": { "optionIndex": 0 } },
    "2idaVTf7GR3jzcGSabVe": { "1": { "optionIndex": 1 } },
    "E1Hwk2WIDqcvjOxyBa11": { "1": { "optionIndex": 1 } },
    "ygIyHj7pIUhgkBhazBJb": { "1": { "optionIndex": 3 } },
    "NhBYPu2p5khticOZ3WvF": { "1": { "optionIndex": 0 } },
    "6RlqxjRY0eBL3O1gz43g": { "1": { "optionIndex": 0 } },
    "ZhzBvzbYuum6I684faQW": { "1": { "optionIndex": 1 } },
    "UbiWkJjVNhqrBbzMEN4Z": { "1": { "optionIndex": 2 } },
    "xlwBysp4htH8JSxWpS70": { "1": { "optionIndex": 0 } },
    "X9XiUGvxhPCGvrr1Tg3q": { "1": { "optionIndex": 2 } },
    "EwmjYJlVwXK01llno1oo": { "1": { "optionIndex": 3 } },
    "MoEOS5Rr9MVOy2IxJCnk": { "1": { "optionIndex": 2 } },
    "BzfDy2WgIXHjL2ChbEIM": { "1": { "optionIndex": 3 } },
    "IXUD7Gmi8woPQ4ebkGMW": { "1": { "optionIndex": 2 } },
    "RkCEj2qP01YMlTu0D4IC": { "1": { "optionIndex": 1 } },
    "GnaDr73h7tQ4vjdpGXXO": { "1": { "optionIndex": 2 } },
    "wgBhJ6qTRlC5nnUI9797": { "1": { "optionIndex": 2 } },
    "rSZABv0A2p1oB83d1Rgg": { "1": { "optionIndex": 0 } },
    "6gjFwZypGLuzpAJh49Pe": { "1": { "optionIndex": 3 } },
    "WjyYGWo0EZG8Zeqs8ABt": { "1": { "optionIndex": 0 } },
    "D29AD1Z64eDGLf6xRKLt": { "1": { "optionIndex": 1 } },
    "4K4Dipw8Iy2PldPxCc7G": { "1": { "optionIndex": 2 } },
    "2zEzs8UzXdUJalwmKPRe": { "1": { "optionIndex": 1 } },
    "xrRKElsXSdwKSAlORAFb": { "1": { "optionIndex": 2 } },
    "TsBjuSxGmNyoe2rkPyrw": { "1": { "optionIndex": 3 } },
    "YOVYOsmzfqzW3EvJrWsZ": { "1": { "optionIndex": 1 } },
    "5sy3s2LCSwaHWuzD8Cyn": { "1": { "optionIndex": 2 } },
    "6nWnaLKde3jdZktQjZbX": { "1": { "optionIndex": 3 } }
}